export const serializeFiltersToQuery = (filters) => {
    const params = new URLSearchParams();

    if (filters.search?.trim()) {
        params.set('se', filters.search.trim());
    }

    const addSet = (key, set) => {
        if (set && set.size > 0) {
            params.set(key, Array.from(set).join(','));
        }
    };

    addSet('sp', filters?.species);
    addSet('m', filters?.manufacturerIds);
    if (filters?.taxonomyTree?.macrofamilyId) {
        params.set('tmf', filters?.taxonomyTree?.macrofamilyId);
    }
    if (filters?.taxonomyTree?.familyId) {
        params.set('tf', filters?.taxonomyTree?.familyId);
    }
    addSet('tsf', filters?.taxonomyTree?.subfamilyIds);

    const characteristics = filters?.characteristics;
    if (characteristics) {
        if (characteristics.featured !== null && characteristics.featured !== undefined) {
            params.set('cf', characteristics.featured);
        }
        if (characteristics.prescription !== null && characteristics.prescription !== undefined) {
            params.set('cp', characteristics.prescription);
        }
    }

    return params;
};

export const parseQueryToFilters = (searchParams) => {
    const getSet = (key, isNumber = true) => {
        const val = searchParams.get(key);
        if (!val) return new Set();
        return new Set(val.split(',').map(v => isNumber ? Number(v) : v));
    };

    return {
        search: searchParams.get('se') || '',
        species: getSet('sp', false),
        manufacturerIds: getSet('m'),
        taxonomyTree: {
            macrofamilyId: searchParams.get('tmf') ? Number(searchParams.get('tmf')) : null,
            familyId: searchParams.get('tf') ? Number(searchParams.get('tf')) : null,
            subfamilyIds: getSet('tsf'),
        },
        characteristics: {
            featured: searchParams.get('cf') ? searchParams.get('cf') === 'true' : null,
            prescription: searchParams.get('cp') ? searchParams.get('cp') === 'true' : null,
        }
    };
};
